<template>
  <div id="app">
    <!-- <dv-full-screen-container> -->
    <router-view></router-view>
    <!-- </dv-full-screen-container> -->
  </div>
</template>
<script>
export default {
  // mounted() {
  //   var w = window.innerWidth;
  //   var h = window.innerHeight;
  //   var lay = document.querySelector("#app");
  //   var ww = lay.clientWidth;
  //   var hh = lay.clientHeight;
  //   lay.style["transform"] = `scale(${w / ww}, ${h / hh})`;
  //   lay.style["transform-origin"] = "left top";
  //   window.addEventListener("resize", function () {
  //     w = window.innerWidth;
  //     h = window.innerHeight;
  //     lay.style["transform"] = `scale(${w / ww}, ${h / hh})`;
  //   });
  // },
};
</script>
<style lang="less" scoped>
#app {
  width: 100vw;
  height: 100vh;
  background-color: #09112b;
}
// body,
// #app {
//   position: fixed;
//   top: 0;
//   left: 0;
//   width: 1920px;
//   height: 1080px;
//   background: #020323;
// }
</style>
